import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturarOrigemCadastro } from 'core/util/OrigemCadastroHelper';

// Captures UTMs that arrive through in-app navigation. Full page loads are
// already captured in index.tsx before the first render.
function TrackOrigemCadastro() {
    const location = useLocation();

    useEffect(() => {
        capturarOrigemCadastro(location.search, location.pathname);
    }, [location.search]);

    return null;
}

export default TrackOrigemCadastro;
